<template>
  <SwapMenu2 swapid="ALL" period="NONE" :title="charttitle" margin="1">
    <template v-slot:menu>
        <li><a  class="dropdown-item" @click=download()>download bar</a></li>
    </template>
  </SwapMenu2>
  <div style="display:flex">
    <div style='font-size:12pt;font-weight:bold;width:80%;height:auto'>
      {{leftdata}} 
    </div>
    <div style='font-size:12pt;font-weight:bold;width:20%;height:auto'>
      {{rightdata}} 
    </div>
  </div>
  <canvas :id="canvasid" style='width:100%;height:auto' @mousemove="showdata($event)"></canvas>
</template>

<script>

var getAbsPosition = function(el){
    var el2 = el;
    var curtop = 0;
    var curleft = 0;
    if (document.getElementById || document.all) {
        do  {
            curleft += el.offsetLeft-el.scrollLeft;
            curtop += el.offsetTop-el.scrollTop;
            el = el.offsetParent;
            el2 = el2.parentNode;
            while (el2 != el) {
                curleft -= el2.scrollLeft;
                curtop -= el2.scrollTop;
                el2 = el2.parentNode;
            }
        } while (el.offsetParent);

    } else if (document.layers) {
        curtop += el.y;
        curleft += el.x;
    }
    return [curtop, curleft];
};
import BarChart from '../js/barchart.js'
import SwapMenu2 from './SwapMenu2.vue' 
export default {
  name: 'BarChart',
  components : {
      SwapMenu2 
  },
  props: {
    globid : String
  },
  mounted() {
  },
  data() {
      return {
         data : [],
         offsetX : 0,
         offsetY : 0,
         charttitle : "CHART",
         graph : "BAR",
         leftdata : "",
         rightdata : "",
         rcsample : { "Q1":16,"Q2":12,"91":18,"51":12,"56":10,"99":1,"A7":5,
                    "B8":10, "C9":100, "D0":50},
         colors : [ "#a55cf5", "#67b6c7", "#bccd7a", "#eb9743", "#839359",
                    "#93ff52", "#ff0099", "#0055ff", "#ee22ff", "#ffff00" ]
      }
  },
  computed : {
    isstart() {
       let swap = this.$store.getters.getswap_byid( parseInt(this.swapid )) ;
       if (! (swap && swap["speedo"])) 
          return false ;
       else 
          return true ;
    },
    canvasid() { return "bar" + this.globid},
    reslist() {
      let res = []
      let i = 0 ;
      Object.keys(this.rcodelist).forEach ( rcode => {
        let newobj = {}
        newobj["style"] = { background : this.colors[i++] } ;
        newobj["code"] =  rcode ;
        res.push(newobj) ;
      }) ;
      return res; 
    }
  },
  methods : {
    showdata(event) {
        if (this.graph == "PIE") {
            this.rightdata = "PIE" ;
            return ;
        }
        if (this.offsetX == 0) {
          let canvas = document.getElementById(this.canvasid);
          let pos = getAbsPosition(canvas) ;
          this.offsetX = pos[1] ; 
          this.offsetY = pos[0] ;
        }
        let x = event.clientX - this.offsetX - 30;
        let len = this.data.length ;
        if (len == 0) return ;
        let barwidth = 320 / len  ;
        let idx = Math.trunc ( x / barwidth ) ;
        if (idx < this.data.length)
          this.rightdata = this.data[idx][1] ;
    },
    drawbar(data, ginfo) {
        let myCanvas = document.getElementById(this.canvasid);
        // let legend = document.querySelector("legend[for='" + this.canvasid + "']");
        let options = {
          canvas: myCanvas,
          seriesName:"Response Code",
          padding:30,
          gridScale:10,
          gridColor:"#eeeeee",

          data: data, 
          colors: this.colors,

          titleOptions: {
            align: "center",
            fill: "black",
            font: {
              weight: "bold",
              size: "12px",
              family: "Lato"
            }
          }
        }

        this.data = data ;
        let vtitle = ginfo.md.toUpperCase() + ' ' + ginfo.base ;
        if (ginfo.md == "monthly")
            vtitle = vtitle + " PERIODE " + ginfo.month ;
        else
            vtitle = vtitle + " PERIODE " + ginfo.day ;
        this.leftdata = vtitle ;
        var myBarchart = new BarChart(options);
        this.charttitle = ginfo.graph + " CHART" ;
        myBarchart.draw(ginfo.graph);
        this.graph = ginfo.graph ;
    }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

